/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import {
  UPDATE_PARAMS,
} from '../../constants/actionType'
// import user from '../../services/api/user'

/**
 * Declare Variable
 */
const updateParamsAction = createAction(UPDATE_PARAMS)

/**
 * Export
 */
export const updateParams = (value) => async (dispatch) => {
  try {
    dispatch(updateParamsAction(value))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/components/query.js